import * as React from 'react';
import Avatar from 'pc-sales/components/Avatar';
import { connect } from 'react-redux';
import Roles from 'pc-sales/service/Roles';

@(connect((state: any) => ({
        user: state.user.get('status')
    }), null) as any)
@Roles({ types: ['sales'], extra: true })
export default class AvatarWrapper extends React.Component<any> {

    render() {
        const { roleMap, user, showUser } = this.props;
        const { firstname, lastname, uroleid, uhead } = user;
        return (
            <Avatar {...{
                roleName: roleMap[uroleid],
                firstName: firstname,
                lastName: lastname,
                uhead: uhead,
                showUser: showUser,
                link: '/personal/info/profile'
            }} style={{
                marginBottom: '0.2rem',
            }}/>
        );
    }
}
